import { useSigma } from "@react-sigma/core";
import { FC, PropsWithChildren, useEffect } from "react";

import { FiltersState } from "../types";

const GraphDataController: FC<PropsWithChildren<{ filters: FiltersState }>> = ({ filters, children }) => {
  const sigma = useSigma();
  const graph = sigma.getGraph();

  /**
   * Apply filters to graphology:
   */
  useEffect(() => {
    const { clusters, tags , datagroups} = filters;
    graph.forEachNode((node, { cluster, tag , datagroup}) =>
      graph.setNodeAttribute(node, "hidden", !clusters[cluster] || !tags[tag] || !datagroups[datagroup]),
    );
  }, [graph, filters]);

  return <>{children}</>;
};

export default GraphDataController;
